import { Select, SelectProps } from '@shared/Form/Select'
import { useAllSessions } from '@services/session'
import { useTranslation } from 'react-i18next'

export default function SessionSelect({ ...props }: SelectProps) {
  const { data } = useAllSessions()

  const { t } = useTranslation()

  return (
    <Select allowClear placeholder={t('device:search sessionName')} {...props}>
      {data
        .filter(x => x.available)
        .filter(x => x.status === 1)
        .map(x => (
          <Select.Option key={x.id} value={x.id}>
            {x.name}
          </Select.Option>
        ))}
    </Select>
  )
}
